import React, { Component } from 'react';
import { connect } from 'react-redux';
import Modal from '../Modal';
import * as modal from '../../reducers/modalReducer';
import RaisedButton from 'material-ui/RaisedButton';
import styled from 'styled-components';
import CloseIcon from '../CloseIcon';
import { BODY_TEXT_COLOR, THIRD_COLOR, ACCENT_COLOR } from '../../config/colors'
import { HeaderDiv, TextDiv } from '../../modals';
import { ArrowLeft } from '../../icons';
// import './style.css'

const styles = {
  closeIcon: { "position":"absolute",top:0,"right":"0","margin":"8px 5px 0 0" },
  labelStyle: {fontWeight:700},
  closeIconWrap: {"position":"absolute","left":"5px",top: '10px', cursor: 'pointer'},
  backIcon: {height:'50px', width:'50px', color: THIRD_COLOR},
  backIconWrap: {"position":"absolute","left":"5px",top: '5px', cursor: 'pointer'},
};

class LoginInfoModal extends Component {
    isNextBtnClicked = false;
    modalStyle = this.props.isSuccess ? { border: '3px solid #' + this.props.secondaryColor } : { border: '3px solid ' + ACCENT_COLOR };

    componentWillMount() {
      if (!this.props.isSuccess) return;
      setTimeout(() => {
          this.onCloseRequest();
      }, 1000)
    }

    onCloseRequest = () => {
      if (this.isNextBtnClicked) return;
        this.props.hideModal();
    }

    handleNextClick = () => {
        this.isNextBtnClicked = true;
        this.props.hideModal();
    }

    handleResetPassword = () => {
      this.props.hideModal();
      setTimeout(() => { this.props.handleResetPassword(); }, 100);
    }

  handleBackBtn = () => {
    this.props.hideModal();
    setTimeout(() => {
      this.props.openLoginForm();
    }, 5);
  }

  render() {
    return (
      <Modal
        noOverlay={true}
        style={this.modalStyle}
        overlayTop={0}
        paddingTop={200}
        closeOnOutsideClick={true}
        isOpened={true}
        onClose={this.onCloseRequest}>
        <ModalWrapperDiv>
            {!this.props.isSuccess && <div onClick={this.onCloseRequest} style={styles.closeIcon}><CloseIcon style={{height:'35px', width:'35px', color: THIRD_COLOR}} /></div> }
            {!this.props.isSuccess && <div onClick={this.handleBackBtn} style={styles.backIconWrap}><ArrowLeft style={styles.backIcon} /></div> }
            {this.props.isSuccess && <HeaderDiv color={BODY_TEXT_COLOR}>LOGIN SUCCESS</HeaderDiv> }
            {!this.props.isSuccess &&
              <div>
               <HeaderDiv color={BODY_TEXT_COLOR}>LOGIN ERROR</HeaderDiv>
               <TextDiv>Username or password incorrect</TextDiv>
              </div>
            }
              <ButtonsWrapperDiv>
                {/*this.props.isSuccess && <RaisedButton
                    onClick={this.handleNextClick}
                    backgroundColor={`#` + this.props.secondaryColor}
                    labelColor="#FFF"
                    label="NEXT"
                    style={styles.button}
                  />*/
                }
                {!this.props.isSuccess && <RaisedButton
                    onClick={this.handleResetPassword}
                    backgroundColor={`#` + this.props.secondaryColor}
                    labelColor="#FFF"
                    label="RESET PASSWORD"
                    labelStyle={styles.labelStyle}
                  />
                }
              </ButtonsWrapperDiv>
        </ModalWrapperDiv>
       </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    primaryColor: state.config.primaryColor,
    secondaryColor: state.config.secondaryColor,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      hideModal: () => dispatch(modal.hideModal()),
      openLoginForm: () => dispatch(modal.openModal({
        modalType: 'LOGIN_FORM',
        modalProps: {
            raisedClass: 'raise'
        }
      })),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginInfoModal);

const ModalWrapperDiv = styled.div `
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 20px auto;
    height: 100%;
    font-family: 'Futura-Bold',  sans-serif;
`;


const ButtonsWrapperDiv = styled.div `
  display: flex;
  justify-content: space-between;
`;




// WEBPACK FOOTER //
// ./src/components/LoginInfoModal/LoginInfoModal.jsx